export default __webpack_public_path__ + "static/media/typewriter1440.39af1bd8.jpg";